import {curry} from 'ramda';
import {maybeArray} from '@pluto/maybe-array';
import {
    utcToZonedTime,
    format,
} from 'date-fns-tz';

export const toMinutes = (value: any) => value / 60;
export const toSeconds = (value: any) => value * 60;

export const getIntervalSecondsValue = (value: any, pollingIntervalType: any) => {
    if (pollingIntervalType === 'EVERY')
        return toSeconds(value);

    return value;
};

export const getIntervalMinutesValue = (value: any, pollingIntervalType: any) => {
    if (pollingIntervalType === 'EVERY')
        return toMinutes(value);

    return value;
};

export const mapMultiFieldChange = (item: any) => item.value;

export const getSingleOnFieldChangeValue = curry((isPolling, e) => {
    if (!e)
        return '';

    return e.value;
});

export const getMultiOnFieldChangeValue = (e: any) => {
    if (!e)
        return '';

    return e.map(mapMultiFieldChange);
};

export const onChangeMultiSelect = curry(({onFieldChange, isMulti, isPolling}, e) => {
    const onChange = isMulti ? getMultiOnFieldChangeValue : getSingleOnFieldChangeValue(isPolling);

    onFieldChange(onChange(e));
});

export const getPollingIntervalTypeValue = ({pollingIntervalType, value}:any) => {
    if (!value)
        return [];

    return value.map(mapPollingIntervalType(pollingIntervalType));
};

export const formatSelectValue = ({isMulti, pollingIntervalType, value}:any) => {
    if (isMulti) {
        return getPollingIntervalTypeValue({
            pollingIntervalType,
            value,
        });
    }

    return [{
        value,
        label: getIntervalMinutesValue(value, pollingIntervalType),
    }];
};

export const formatDate = (value: any) => {
    if (!value)
        return '';

    const {timeZone} = Intl.DateTimeFormat().resolvedOptions();
    const [dateValue] = maybeArray(value);
    const timeZonedDate = utcToZonedTime(dateValue, timeZone);
    const [date, time] = format(timeZonedDate, 'yyyy-MM-dd HH:mm').split(' ');

    return `${date}T${time}`;
};

export const formatDateToServer = (date: any) => {
    if (date) {
        return new Date(date).toISOString();
    }
    return '';
};

export const mapPollingIntervalType = curry((pollingIntervalType, item) => ({
    value: getIntervalSecondsValue(item, pollingIntervalType),
    label: item,
}));
